import r from "./_ListCache.js";
import a from "./_stackClear.js";
import p from "./_stackDelete.js";
import s from "./_stackGet.js";
import i from "./_stackHas.js";
import m from "./_stackSet.js";
function t(o) {
  var e = this.__data__ = new r(o);
  this.size = e.size;
}
t.prototype.clear = a;
t.prototype.delete = p;
t.prototype.get = s;
t.prototype.has = i;
t.prototype.set = m;
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_Stack.js
// module id = 309
// module chunks = 67